import { useAppKit } from '@reown/appkit/react';
import { useCallback, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useAccount } from 'wagmi';

import { Button } from 'common/components';

import { useI18n, usePopup } from 'common/hooks';

import { memoizedComponent } from 'utils/memoizeComponent';

import './index.css';

export const Web3ConnectWelcomePopup = memoizedComponent(() => {
  const { hide } = usePopup();
  const { translate } = useI18n();
  const { isConnected } = useAccount();
  const { open } = useAppKit();

  const initialSlide = useMemo(() => (isConnected ? 1 : 0), [isConnected]);

  const onConnect = useCallback(async () => {
    await open({ view: 'Connect' });
    hide();
  }, [hide, open]);

  return (
    <div className='web3-connect-welcome'>
      <div className='web3-connect-welcome__decor'>{translate.toText('mobile:wallets:web3:connect:new')} &#127881;</div>
      <h2 className='web3-connect-welcome__title'>{translate.toText('mobile:wallets:web3:connect:title')}</h2>
      <p className='web3-connect-welcome__desc'>{translate.toText('mobile:wallets:web3:connect:description')}</p>

      <Swiper
        autoHeight
        allowTouchMove={false}
        slidesPerView={1}
        initialSlide={initialSlide}
        speed={150}
        style={{ width: '100%' }}
      >
        <SwiperSlide>
          <div className='flex flex-column flex-align-center gap-24'>
            <ul className='web3-connect-welcome__list'>
              <li className='web3-connect-welcome__list-item'>
                <span className='web3-connect-welcome__list-item-marker'>1</span>
                {translate.toText('mobile:wallets:web3:connect:actions:1')}
              </li>
              <li className='web3-connect-welcome__list-item'>
                <span className='web3-connect-welcome__list-item-marker'>2</span>
                {translate.toText('mobile:wallets:web3:connect:actions:2')}
              </li>
              <li className='web3-connect-welcome__list-item'>
                <span className='web3-connect-welcome__list-item-marker'>3</span>
                {translate.toText('mobile:wallets:web3:connect:actions:3')}
              </li>
            </ul>
            <Button large className='web3-connect' onClick={onConnect}>
              {translate.toText('mobile:wallets:web3:connect:button:primary')}
            </Button>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
});
